import React from 'react';

/** Applied to table rows when checked/selected in allocation and shipment grids. */
export const SELECTED_ROW_CLASS = 'data-grid-row-selected';

export const selectedRowClassName = (isSelected, baseClass = '') =>
  (isSelected ? `${SELECTED_ROW_CLASS} ${baseClass}` : baseClass).trim();

/** Truncated table cell text with full value in tooltip. */
export function GridText({ value, className = '', title }) {
  const text = value == null || value === '' ? '-' : String(value);
  return (
    <span className={`block truncate ${className}`} title={title ?? text}>
      {text}
    </span>
  );
}

/** Multi-line clamp for addresses / remarks. */
export function GridClamp({ value, lines = 2, className = '' }) {
  const text = value == null || value === '' ? '-' : String(value);
  const clampClass = lines === 2 ? 'line-clamp-2' : `line-clamp-${lines}`;
  return (
    <span className={`block ${clampClass} cursor-help ${className}`} title={text}>
      {text}
    </span>
  );
}

export function StatusPill({ name, color }) {
  if (!name) return <GridText value="-" />;
  return (
    <span
      className="inline-flex max-w-full items-center overflow-hidden rounded-full px-3 py-1.5 text-xs font-semibold text-white"
      style={{
        background: color
          ? `linear-gradient(to right, ${color} 0%, ${color} 45%, ${color}cc 50%, ${color}aa 100%)`
          : 'linear-gradient(to right, #2563EB 0%, #2563EB 45%, #3B82F6 50%, #60A5FA 100%)',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.15)',
      }}
      title={name}
    >
      <span className="truncate">{name}</span>
    </span>
  );
}
